module.exports = __webpack_public_path__ + "img/Irini-Karaiskaki.acc3082d.jpg";